import { render, staticRenderFns } from "./EnrollJoinPane.vue?vue&type=template&id=38d7643b&scoped=true"
import script from "./EnrollJoinPane.vue?vue&type=script&lang=js"
export * from "./EnrollJoinPane.vue?vue&type=script&lang=js"
import style0 from "./EnrollJoinPane.vue?vue&type=style&index=0&id=38d7643b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d7643b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38d7643b')) {
      api.createRecord('38d7643b', component.options)
    } else {
      api.reload('38d7643b', component.options)
    }
    module.hot.accept("./EnrollJoinPane.vue?vue&type=template&id=38d7643b&scoped=true", function () {
      api.rerender('38d7643b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/enroll/EnrollJoinPane.vue"
export default component.exports